export default {
  mapEditable: true,
  Tecnico: '',
  incidencia: {},
  idCliente: null,
  idInstalacion: null
}
